export const Feedback_DA = {
  feedback: {
    heading: "Feedback",
    desc: "Vi vil gerne høre din feedback, så vi kan forbedre vores platform, Game Tracker og din spiloplevelse.",
    fields: {
      type: {
        label: "Feedback type",
        bug: "Jeg har fundet en fejl",
        feature: "Anmodning om nye funktioner",
        general: "Generel feedback",
        other: "Andet",
      },
      details: {
        label: "Hvad vil du fortælle os?",
        placeholder: "Indtast din besked...",
      },
      button: {
        label: "Send feedback",
      },
    },
    success: "Vi har modtaget din feedback. Tak!",
    error: "Noget gik galt: ",
  },
};
